import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3956c02d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "dropTxt" }
const _hoisted_4 = { class: "choBtnTxt" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "max" }, "Max.File Size: 20 MB", -1))
const _hoisted_6 = {
  key: 0,
  class: "file"
}

import { ElMessage } from "element-plus";
import { ref } from "vue";

import { MyImage } from "@icon/MyImage";
import { MyUtil } from "@util";
import { postUploadFile } from "@/views/home/api";

interface Item {
  lab: string
  lab_?: string
  callback: (res: { file: File, url: string }) => void
  file?: File,
  url?: string
}
interface Props {
  item: Item
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MyUploadFile',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props
const handleDrop = (e: any) => {
  e.preventDefault();
  const { files } = e.dataTransfer;
  return changFile(files[0]);
};

const changFile = (e: any) => {
  const file = e.target?.files[0];
  const tp = MyUtil.getFileType(file.name);
  if (tp != "doc" && tp != "docx") {
    ElMessage({
      showClose: true,
      message: "Unsupported file format",
      duration: 5000,
    });
    return;
  }
  upload(file);
  e.target.value = "";
};

const loading = ref(false);
const upload = async (file: File) => {
  const fd = new FormData();
  fd.append("file", file);
  loading.value = true;
  postUploadFile(fd)
    .then(({ data }) => {
      loading.value = false;
      const {
        resp: { code, msg },
        url,
      } = data;
      if (code == 0) {
        MyUtil.log("url==", url);
        props.item.callback({ file, url })
        // fileSel.value = file;
        // reportUrl.value = url;
      } else {
        ElMessage.error(msg);
      }
    })
    .catch((err) => {
      loading.value = false;
      ElMessage.error(err.message);
      MyUtil.log("err==", err);
    });
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    onDrop: handleDrop,
    id: "drag",
    onDragleave: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    onDragenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
    onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(props.item.lab_ || props.item.lab), 1),
    _createElementVNode("img", {
      src: _unref(MyImage).ass.doc,
      class: "docImg",
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, "Drop your " + _toDisplayString(props.item.lab) + " here or ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(" Choose file "),
        _createElementVNode("input", {
          type: "file",
          class: "fileBtn",
          multiple: "",
          required: "",
          onChange: changFile
        }, null, 32)
      ])
    ]),
    _hoisted_5,
    (props.item.url)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(MyUtil).getFileName(props.item.url)), 1))
      : _createCommentVNode("", true)
  ], 32)), [
    [_directive_loading, loading.value]
  ])
}
}

})